import apiClient from "./apiClient";
const resource = "/auth";

export default {
  async getCSRFCookie() {
    return apiClient.get("/sanctum/csrf-cookie");
  },
  async login(data) {
    await this.getCSRFCookie();
    return apiClient.post(`${resource}/login`, data);
  },
  async getUser() {
    return apiClient.get(`/user`);
  },
  async logout() {
    return apiClient.post(`${resource}/logout`);
  },
  //   async create(data) {
  //     return apiClient.post(`${resource}`, data);
  //   },
  //   async getById(uuid) {
  //     return apiClient.get(`${resource}/${uuid}`);
  //   },
  //   async update(data, uuid) {
  //     return apiClient.put(`${resource}/${uuid}`, data);
  //   },
  //   async delete(uuid) {
  //     return apiClient.delete(`${resource}/${uuid}`);
  //   },
  //   async search(keyword) {
  //     return apiClient.get(`${resource}/search?keyword=${keyword}`);
  //   },
};
